// src/App.js
import { BrowserRouter } from "react-router-dom";
import { PermissionProvider } from "./context/PermissionContext";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import { ErrorBoundary } from "react-error-boundary";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import AnalyticsWrapper from "./hook/useAnalytics";
import AppRoutes from "./routes/AppRoutes";
import ErrorAlert from "./components/ui/ErrorAlert";

const loadPage = () => {
  window.location.reload();
};
// Fallback component for errors
const ErrorFallback = ({ error }) => {
  return (
    <div className="bg-danger">
      <ErrorAlert error={error} onRetry={loadPage} />
    </div>
  );
};

function App() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <PermissionProvider>
        <BrowserRouter>
          <RouteScrollToTop />
          {/* <AnalyticsWrapper /> */}
          <AppRoutes />
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss={false}
            draggable={false}
            pauseOnHover={false}
            closeButton={false}
            toastClassName="rounded-5 shadow-md"
          />
        </BrowserRouter>
      </PermissionProvider>
    </ErrorBoundary>
  );
}

export default App;
